<template>
    <div class="body">
      <iframe
        class="content-box"
        :src="url"
        frameborder="0">
      </iframe>
    </div>
</template>

<script>
	export default {
	    data(){
        return{
          url:""
        }
		},
    mounted() {
        console.log(222)
      if(this.$route.query.iscn == '1'){
        // 合规版
        if(this.$route.query.inviter){
          this.url="https://cn.neco.club/?inviter="+this.$route.query.inviter + '&lang=' + this.$route.query.lang
        }else{
          this.url="https://cn.neco.club/?lang="+this.$route.query.lang
        }
      }else{
        if(this.$route.query.inviter){
          this.url="https://web.neco.ltd/?inviter="+this.$route.query.inviter + '&lang=' + this.$route.query.lang
        }else{
          this.url="https://web.neco.ltd/?lang="+this.$route.query.lang
        }
      }

    },
  }
</script>

<style scoped>
.body{
  width: 100%;
  height: 100%;
  display: flex;
  background: #F2F4F6;
  align-items: center;
  min-width: 1366px;
}
.content-box{
  width: 375px;
  height: 100vh;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Lobby/index.vue